import { INTERPRETER_BASE_URL } from "../config/runtime";

// The /api/segment router is mounted on the interpreter service (it proxies
// to the compiler), not the visualizer — using VISUALIZER_BASE_URL here 404s.
const base = (INTERPRETER_BASE_URL || "").replace(/\/$/, "");

function withRefParam(userId, referenceId) {
  let qs = `user_id=${encodeURIComponent(userId)}`;
  if (referenceId != null) qs += `&reference_id=${encodeURIComponent(referenceId)}`;
  return qs;
}

export async function saveAnnotations(
  dpmUuid,
  stepId,
  userId,
  annotations,
  referenceId = null
) {
  const res = await fetch(
    `${base}/api/segment/dpm/${dpmUuid}/steps/${stepId}/annotations?${withRefParam(userId, referenceId)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ annotations }),
    }
  );
  if (!res.ok) throw new Error(`saveAnnotations failed: ${res.status}`);
  return res.json();
}
